import React, { useEffect, useState } from 'react'

import * as R from 'ramda'
import { Form, Segment } from 'semantic-ui-react'

import { Loader } from 'shared/components/Loader'
import EmptyState from 'shared/components/EmptyState'
import { NewTabLink } from 'components/NewTabLink'
import EditUserSurveyAccessFormContent from '.'

/**
 *
 * @param {object} props
 * @param {*[]} props.defaultSurveyAccesses
 * @param {function} props.onChange
 * @param {boolean} [props.loading]
 */
export default function EditUserSurveyAccessInputContainer({
  defaultSurveyAccesses,
  onChange,
  loading,
}) {
  const [surveyAccesses, setSurveyAccesses] = useState(defaultSurveyAccesses || [])
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    if (defaultSurveyAccesses) {
      setSurveyAccesses(defaultSurveyAccesses)
    }
  }, [defaultSurveyAccesses])

  useEffect(() => {
    onChange(surveyAccesses)
  }, [onChange, surveyAccesses])

  if (loading) {
    return (
      <Form>
        <Form.Field>
          <label>Survey access</label>
        </Form.Field>
        <Loader withContainer />
      </Form>
    )
  }

  if (!defaultSurveyAccesses || defaultSurveyAccesses.length === 0) {
    return (
      <div className="ui form">
        <Form.Field>
          <label>Survey access</label>
        </Form.Field>
        <Form.Group grouped>
          <Segment>
            <Form.Field>
              <EmptyState
                icon={<i className="far fa-poll-h" />}
                callToAction={
                  <NewTabLink to="/settings/surveys/?create=true">Create a new survey.</NewTabLink>
                }
              >
                Your account doesn't have any surveys yet.
              </EmptyState>
            </Form.Field>
          </Segment>
        </Form.Group>
      </div>
    )
  }

  const _sortByName = R.sortBy(R.prop('name'))
  const filteredSurvey = _sortByName(surveyAccesses).filter((survey) => {
    if (searchTerm) {
      return survey.name.toLowerCase().includes(searchTerm.toLowerCase())
    }
    return true
  })

  function handleSearchChange(_, { value }) {
    setSearchTerm(value)
  }
  function selectAllOptions() {
    const selectAllSurvey = surveyAccesses.map((survey) => ({ ...survey, has_permission: true }))
    setSurveyAccesses(selectAllSurvey)
  }
  function clearAllOptions() {
    const deselectAllSurvey = surveyAccesses.map((survey) => ({ ...survey, has_permission: false }))
    setSurveyAccesses(deselectAllSurvey)
  }

  function onCheckboxChange(targetSurvey) {
    const targetSurveyIndex = surveyAccesses.findIndex(
      (survey) => survey.survey_id === targetSurvey.survey_id
    )
    const updatedSurveyAccess = R.assocPath(
      [targetSurveyIndex, 'has_permission'],
      !targetSurvey.has_permission,
      surveyAccesses
    )
    setSurveyAccesses(updatedSurveyAccess)
  }

  return (
    <EditUserSurveyAccessFormContent
      surveys={filteredSurvey}
      handleSearchChange={handleSearchChange}
      selectAllOptions={selectAllOptions}
      clearAllOptions={clearAllOptions}
      onCheckboxChange={onCheckboxChange}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EditUserSurveyAccessInput/container.js